import * as React from "react";
import ErrorPage from "./containers/ErrorPage";
import i18n from "./config/i18next";

interface IErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<{}, IErrorBoundaryState> {
  constructor(props: any) {
    super(props);

    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError(error: Error) {
    return {
      hasError: true,
    };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    console.log(error);
  }

  render() {
    if (this.state.hasError) {
      return <ErrorPage message={i18n.t("internal.server.error")} />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
